import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export abstract class BasicHttpClientService {
  public abstract get<T>(fragment: string, params?: HttpParams): Observable<T>;
  public abstract post<TBody, T>(fragment: string, body: TBody, params?: HttpParams): Observable<T>;
  public abstract put<TBody, T>(fragment: string, body: TBody, params?: HttpParams): Observable<T>;
}
